export const DocumentType = Object.freeze({
    CPF: 1,
    CNPJ: 2
})